import React, { useState, useCallback } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { useLanguage } from '../../../../contexts/LanguageContext';

const RejectRequestDialog = ({ visible, onHide, onReject, isRejecting }) => {
    const { th } = useLanguage();
    const [rejectionReason, setRejectionReason] = useState('');

    const handleReject = useCallback(() => {
        onReject(rejectionReason || null);
    }, [onReject, rejectionReason]);

    const handleHide = useCallback(() => {
        setRejectionReason('');
        onHide();
    }, [onHide]);

    const dialogFooter = (
        <div className="flex justify-content-end gap-2">
            <Button
                label={th('common.cancel')}
                icon="pi pi-times"
                className="p-button-outlined"
                onClick={handleHide}
                disabled={isRejecting}
            />
            <Button
                label={th('dealerPartsReturnProcess.actions.reject')}
                icon="pi pi-times"
                className="p-button-danger"
                onClick={handleReject}
                loading={isRejecting}
            />
        </div>
    );

    return (
        <Dialog
            visible={visible}
            onHide={handleHide}
            header={th('dealerPartsReturnProcess.rejectRequest')}
            footer={dialogFooter}
            style={{ width: '450px' }}
            modal
            closable={!isRejecting}
            closeOnEscape={!isRejecting}
        >
            <div className="p-fluid">
                <div className="field">
                    <label htmlFor="rejectionReason" className="font-medium mb-2 block">
                        {th('dealerPartsReturnProcess.rejectionReasonOptional')}
                    </label>
                    <InputTextarea
                        id="rejectionReason"
                        value={rejectionReason}
                        onChange={(e) => setRejectionReason(e.target.value)}
                        rows={5}
                        placeholder={th('dealerPartsReturnProcess.rejectionReasonPlaceholder')}
                        disabled={isRejecting}
                        autoResize
                    />
                </div>
            </div>
        </Dialog>
    );
};

export default RejectRequestDialog;
